export default "__VITE_ASSET__674d9ab9__"